import { Injectable } from '@angular/core';
import { ActivityInternal } from '../activity-internal/activity-internal.service';
import { GungCalendarItem } from 'gung-common';
import { GungModalService } from '../gung-modal/gung-modal.service';
import { MetadataService } from '../metadata/metadata.service';

@Injectable({
  providedIn: 'root'
})
export class ActivityInternalCalendarItemMapperService {
  constructor(
    protected gungModalService: GungModalService,
    protected metadataService: MetadataService
  ) {}

  public mapToCalendarItems(activities: ActivityInternal[]): GungCalendarItem[] {
    const result = [];
    for (const activity of activities) {
      result.push({
        id: activity.id,
        date: new Date(activity.activityDate),
        heading: activity.customerName,
        action: () => this.editActivity(activity),
        class: `status-${this.metadataService.getMetadataValue('ACTIVITYINTERNALSTATUS', 'name', activity.status)?.toLowerCase()}`
      });
    }
    return result;
  }

  protected editActivity(activity: ActivityInternal) {
    this.gungModalService.openViewActivityModal(activity).then(
      result => {},
      reject => {}
    );
  }
}
